import { render, staticRenderFns } from "./MemberSummarySideBar.vue?vue&type=template&id=5358ae9e&scoped=true&"
import script from "./MemberSummarySideBar.vue?vue&type=script&lang=js&"
export * from "./MemberSummarySideBar.vue?vue&type=script&lang=js&"
import style0 from "./MemberSummarySideBar.vue?vue&type=style&index=0&id=5358ae9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358ae9e",
  null
  
)

export default component.exports